import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './Accordion';
const faqs = [{
  q: '¿Qué recibo al comprar?',
  a: 'Recibirás acceso inmediato al E-book principal en formato PDF de alta calidad, junto con todos los bonos exclusivos detallados en la página. Todo el material es descargable.'
}, {
  q: '¿Es físico o digital?',
  a: 'Es un producto 100% digital. Esto nos permite mantener el precio accesible y darte acceso inmediato sin importar en qué parte del mundo te encuentres.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'Necesitas experiencia básica en cocina, pero no necesitas experiencia previa en yates o embarcaciones. La guía está diseñada para enseñarte cómo hacer la transición.'
}, {
  q: '¿Cuándo recibo acceso?',
  a: 'Inmediatamente después de confirmar el pago. Recibirás un correo electrónico con los enlaces de descarga directa a todo el material.'
}, {
  q: '¿Necesito ser chef certificado?',
  a: 'No es estrictamente necesario tener un título universitario, pero sí experiencia comprobable en cocina. En la guía te explicamos cómo presentar tu experiencia de la mejor manera.'
}, {
  q: '¿Necesito hablar inglés perfecto?',
  a: 'No necesitas un inglés perfecto, pero sí un nivel conversacional básico/intermedio para comunicarte con la tripulación. El bono de inglés te ayudará con el vocabulario específico.'
}, {
  q: '¿Tengo acceso para siempre?',
  a: 'Sí, el pago es único y tendrás acceso de por vida al material, incluyendo cualquier actualización futura que hagamos a la guía.'
}, {
  q: '¿La compra es segura?',
  a: 'Totalmente. Procesamos los pagos a través de plataformas seguras y encriptadas. Además, cuentas con nuestra garantía de devolución de 7 días.'
}];
export function FAQ() {
  return <section className="py-16 bg-background" data-id="element-62">
      <div className="px-5" data-id="element-63">
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-64">
          <h2 className="text-3xl font-bold text-white font-heading mb-3 leading-tight" data-id="element-65">
            Preguntas
            <br data-id="element-66" />
            Frecuentes
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-67"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-68">
          <Accordion type="single" collapsible className="w-full space-y-3" data-id="element-69">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="bg-secondary/30 border border-border/50 rounded-xl px-4 data-[state=open]:border-primary/50 transition-colors" data-id="element-70">
                <AccordionTrigger className="text-left text-white/90 hover:text-white hover:no-underline py-4 text-sm font-medium" data-id="element-71">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-sm leading-relaxed pb-4" data-id="element-72">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </motion.div>
      </div>
    </section>;
}